import React, { useState } from 'react';
import QuantityCard from '../../components/SupplierBidComponents/QuantityCard';
import {
  ArrowTopRightOnSquareIcon,
  PaperAirplaneIcon,
} from '@heroicons/react/24/outline';
import { useSelector } from 'react-redux';

const BidSubmitScreen = ({ handleTabChange }) => {
  const user = useSelector((state) => state?.authReducer?.user);
  const [productionTime, setProductionTime] = useState();
  const [expectedDeliveryDate, setExpectedDeliveryDate] = useState();
  const [comment, setComment] = useState('');

  const handleCommentSubmit = () => {
    // setting comment data
  };

  return (
    <div className="min-w-screen">
      <div className="space-y-3">
        <div className="grid grid-cols-5 text-left block p-4 pl-10 border border-[#DDDDDD] rounded-2xl items-center">
          <div className="col-end-2 space-y-2">
            <div className="tracking-tight text-gray-900 text-[25px] mb-5">
              Quote No.
            </div>
            <div className="p-2 border border-[#DDDDDD] rounded-2xl">
              12312312312
            </div>
          </div>
          <div className="space-y-2 col-start-5">
            <h5 className="tracking-tight text-gray-900 text-[25px] mb-5">
              Valid Until
            </h5>
            <div className="p-2 border border-[#DDDDDD] rounded-2xl">
              02/20/2040
            </div>
          </div>
        </div>
        <div className="grid grid-cols-5 block text-left p-4 pl-10 bg-white border border-[#DDDDDD] rounded-2xl items-center">
          <div className="col-end-2 space-y-2">
            <div className="tracking-tight text-gray-900 text-[25px] mb-5">
              Production Time
            </div>
            <div className="">
              <input
                type="text"
                className="p-2 border border-[#DDDDDD] rounded-2xl"
                placeholder="00"
                value={productionTime}
                onChange={(e) => setProductionTime(e.target.value)}
              />
            </div>
          </div>
          <div className="col-start-5 space-y-2">
            <div className="tracking-tight text-gray-900 text-[23px] mb-5">
              Expected Delivery
            </div>
            <input
              type="text"
              className="p-2 border border-[#DDDDDD] rounded-2xl"
              placeholder="00"
              value={expectedDeliveryDate}
              onChange={(e) => setExpectedDeliveryDate(e.target.value)}
            />
          </div>
        </div>
        <QuantityCard />
        <div className="block p-4 pl-10 border border-[#DDDDDD] rounded-2xl items-center">
          <div className="flex flex-row space-x-4 grid grid-cols-6">
            <div className="tracking-tight text-gray-900 text-[25px] font-bold">
              Subtotal :
            </div>
            <div className="tracking-tight text-gray-900 text-[25px]">
              $25000
            </div>
          </div>
        </div>
        <div className="block p-4 pl-10 border border-[#DDDDDD] rounded-2xl items-center space-y-5">
          <div className="flex flex-row justify-between space-x-4">
            <div className="tracking-tight text-gray-900 text-[25px] font-bold">
              Additional Comments :
            </div>
            <ArrowTopRightOnSquareIcon className="w-6 h-6 mt-2" />
          </div>
          <div className="flex flex-row px-5 py-2 border border-neutral-200 rounded-2xl items-center">
            <div>
              <img
                className="h-12 w-12 rounded-full"
                src={user?.picture}
                alt="user"
              />
            </div>
            <div className="flex-grow px-5">
              <input
                type="text"
                name="comment"
                id="comment"
                className="relative px-2 py-1 bg-white w-full rounded-full hover:cursor-pointer text-[13.33px] font-normal focus:outline-none placeholder:text-black sm:text-sm sm:leading-6 placeholder:italic placeholder:text-[13.33px]"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleCommentSubmit();
                  }
                }}
                placeholder="Add a suggestion or comment..."
              />
            </div>
            <PaperAirplaneIcon
              className="h-6 w-6 hover:cursor-pointer"
              onClick={() => handleCommentSubmit()}
            />
          </div>
        </div>
        <div className="flex flex-row items-center justify-center space-x-6">
          <button className="rounded-full px-8 py-2 text-[18px] text-center my-1 border-[1px] border-black min-w-[180px]">
            Save
          </button>
          <button
            className="rounded-full px-8 py-2 text-[18px] text-center my-1 bg-blue-400 text-white font-bold min-w-[180px]"
            // onClick={() => navigate(`/user/bid/submit/${quoteNo}`)}
          >
            Submit Bid
          </button>
          <button
            className="rounded-full px-8 py-2 text-[18px] text-center my-1 border-[1px] border-black min-w-[180px]"
            onClick={() => handleTabChange('review_quote')}
          >
            Previous Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default BidSubmitScreen;
